import { assign } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
} from '../../../types';

export const getProductWithMeasurementsSuccess = assign(
  (
    context: ProductBuilderMachineContext,
    event: ProductBuilderMachineEvent,
  ) => {
    if (
      event.type !==
      'done.invoke.productBuilder.measurements.loading:invocation[0]'
    )
      return context;
    return {
      ...context,
      productWithMeasurements: event.data,
    };
  },
);
